import { SlicePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatPaginatorIntl, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { RouterLink } from '@angular/router';
import { WINDOW } from '@ng-web-apis/common';
import { I18NextModule } from 'angular-i18next';
import { BaseComponent } from 'src/app/_shared/components/base/base.component';
import { IconComponent } from 'src/app/common/icon/icon.component';
import { PaginatorItaService } from 'src/app/common/paginator-ita.service';
import { RouteTranslatePipe } from 'src/app/_shared/pipes/route-translate.pipe';
import { FaqBody } from 'src/types/graphql';

@Component({
  selector: 'sharry-faq-search',
  templateUrl: './faq-search.component.html',
  styleUrls: ['./../faq.component.scss'],
  standalone: true,
  imports: [
    SlicePipe,
    MatExpansionModule,
    I18NextModule,
    RouterLink,
    MatPaginatorModule,
    RouteTranslatePipe,
    IconComponent,
  ],
  providers: [{ provide: MatPaginatorIntl, useClass: PaginatorItaService }],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FaqSearchComponent extends BaseComponent {
  @Input() faqBodies: FaqBody[] = [];
  @Output() back: EventEmitter<void> = new EventEmitter();
  pageSize = 10;
  index = 0;

  constructor(@Inject(WINDOW) private window: Window) {
    super();
  }

  onNoResultClick() {
    this.back.emit();
  }

  goToPage(event: PageEvent) {
    this.index = event.pageIndex;
    this.window.scrollTo(0, 0);
  }
}
